import styled from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const SectionWrapper = styled.div`
  padding-inline: 16px;
  color: var(--textAndLabels-main);

  &:last-child {
    margin-top: 20px;
  }

  @media (max-width: ${CONTAINER_MAX.mobileM}) {
    padding-inline: 12px;
  }
`;

export const NavigationItemWrapper = styled.div`
  ${flexColumn};
  row-gap: 24px;
  color: var(--textAndLabels-main);
`;
